(function () {
    'use strict';

    // @ngInject
    Services.momentJS = function momentJS($window) {
        return $window.moment;
    };

}());
